const INIT_STATE = { data: [], error: null };
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "ALL_REGISTERED_TRAININGS_SUCCESS":
      return {
        ...state,
        data: action.payload,
        error: null,
      };
    case "ALL_REGISTERED_TRAININGS_ERROR":
      return { ...state, data: [], error: action.payload };
    default:
      return state;
  }
};
